module.exports = __webpack_public_path__ + "static/media/iPhoneDevice.6c95768b.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/iPhoneDevice.gif
 ** module id = 638
 ** module chunks = 0
 **/